import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const OrderSuccess = () => {

    useEffect(() => {
        // 1. Load gtag.js script
        const gtagScript = document.createElement("script");
        gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-759751310";
        gtagScript.async = true;
        gtagScript.id = "gtag-script";
        document.head.appendChild(gtagScript);
    
        // 2. Add inline gtag config script
        const inlineScript = document.createElement("script");
        inlineScript.id = "gtag-config";
        inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'AW-759751310');
        `;
        document.head.appendChild(inlineScript);
    
        // Cleanup when component unmounts
        return () => {
          const addedScript = document.getElementById("gtag-script");
          const configScript = document.getElementById("gtag-config");
          if (addedScript) addedScript.remove();
          if (configScript) configScript.remove();
        };
      }, []);
    return (
        <>
        <Navbar />
            <div class="header-details" style={{ height: '100px', background: 'black' }}></div>
            <div style={{ marginTop: '10rem', marginBottom: '10rem' }}>
                <div className="text-center">
                    <h2>Your order has been successfully placed!</h2>
                    <p>Thank you for your purchase.</p>
                    <p>Please click <a href="/profile">here</a> to go back to your profile.</p>
                </div>
            </div>
        <Footer />
        </>
    );
};

export default OrderSuccess;
